import _ from "lodash";
import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { useParams, useLocation } from "react-router-dom";
import qs from "query-string";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

import IntlMessages from "util/intlMessages";
import ChannelMessageData from "./Data";
import { adminAPI } from "redux/api";
import { apiUrls } from "../init";

const { api } = adminAPI.actions;

const ChannelMessageForm = (props) => {
  // const params = useParams();
  // const location = useLocation();
  const [message, setMessage] = useState(null);

  useEffect(() => {
    setMessage(props.message);
  }, [props.message]);
  
  const [paramsValue, setParamsValue] = useState({});
  useEffect(() => {
    // const query = qs.parse(location.search);
    message && setParamsValue({ messageId: message._id, channelId: message.channelId });
  }, [message]);

  const saveHandler = (req, res) => {
    res.onSuccess = (body) => {
      props.refreshHandler();
      // toggleModal();
    };
    props.saveData({ ...req, params: { ...paramsValue } }, res);
  };

  const [openModal, setOpenModal] = useState(false);
  const toggleModal = () => setOpenModal(!openModal);

  useEffect(() => {
    setMessage(props.message);
  }, [openModal]);

  const removeHandler = () => {
    const res = {
      onSuccess() {
        props.refreshHandler();
      },
    };
    const isConfirmed = window.confirm("Удалить сообщение?");
    if (isConfirmed) {
      props.removeData({ params: { ...paramsValue } }, res);
    }
  };

  return (
    <span className="text-nowrap">
      <button className="btn btn-sm btn-secondary" onClick={toggleModal}>
        <i className="fa fa-edit" />
      </button>

      {props.removeButton ? (
        <button className="btn btn-sm btn-danger ml-1" onClick={removeHandler}>
          <i className="fa fa-times" />
        </button>
      ) : null}

      {/* <GetMessagesButton {...channel} /> */}
      {/* <GetInfoButton {...channel} /> */}

      {openModal && (
        <Modal isOpen={openModal} centered size="lg" toggle={toggleModal}>
          <ModalHeader toggle={toggleModal}>
            <IntlMessages id={"edit"} />
          </ModalHeader>
          <ModalBody>
            <ChannelMessageData {...{ message, setMessage, saveHandler }} />
          </ModalBody>
        </Modal>
      )}
    </span>
  );
};

export default connect(null, {
  saveData: api.put(apiUrls.messageInfo),
  removeData: api.delete(apiUrls.messageInfo),
})(ChannelMessageForm);
